import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="relative bg-accent-950 text-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 md:px-6 pt-16 md:pt-20 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-14">
          <div>
        <Link
          to="/"
          className="font-heading text-xl font-bold tracking-tight whitespace-nowrap cursor-pointer"
        >
          cssspreadsheet<span className="text-accent-400">.</span>makeup
        </Link>
            <p className="text-white/50 text-sm mt-3 leading-relaxed max-w-xs">
              The most comprehensive CSSBuy spreadsheet database. Updated daily with verified product links
              across multiple agent platforms.
            </p>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-widest text-white/40 font-semibold mb-4">
              Categories
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">Shoes</a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">Hoodies &amp; Sweaters</a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">T-Shirts</a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">Jackets</a>
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-widest text-white/40 font-semibold mb-4">
              Quick Links
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-white/60 text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">Home</Link>
              <Link to="/article/cssbuy-spreadsheet-2026-guide" className="text-white/60 text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">2026 Guide</Link>
              <Link to="/article/kakobuy-vs-cssbuy-comparison" className="text-white/60 text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">Kakobuy vs CSSBuy</Link>
              <Link to="/article/best-budget-finds-2026" className="text-white/60 text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">Budget Finds 2026</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-white/60 text-sm hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">Kaspreadsheet</a>
            </div>
          </div>

          <div>
            <h4 className="font-label text-xs uppercase tracking-widest text-white/40 font-semibold mb-4">
              Agent Platforms
            </h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-white/50 text-sm cursor-default">CSSBuy Spreadsheet</span>
              <span className="text-white/50 text-sm cursor-default">Kakobuy Spreadsheet</span>
              <span className="text-white/50 text-sm cursor-default">Superbuy Spreadsheet</span>
              <span className="text-white/50 text-sm cursor-default">Oopbuy Spreadsheet</span>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} cssspreadsheet.makeup — All external links open in new tabs.
          </p>
          <p className="text-white/30 text-xs">
            Built for the spreadsheet shopping community.
          </p>
        </div>
      </div>

      <div className="w-full py-8 bg-accent-950/80 flex items-center justify-center overflow-hidden">
        <span className="font-heading text-[60px] md:text-[100px] lg:text-[140px] font-extrabold text-white/8 tracking-[-0.04em] whitespace-nowrap leading-none select-none">
          CSSBUY SHEET
        </span>
      </div>
    </footer>
  );
}